<template>
  <v-container pa-5>
    <v-layout row
              wrap>
      <v-flex md10 xs12
              pt-3>
        <v-combobox v-model="dataset"
                    :items="datasets"
                    item-text="title"
                    item-value="name"
                    label="Zbiór danych"></v-combobox>
      </v-flex>
      <v-flex md2 xs12
              pa-3
              text-xs-center>
        <v-btn @click="downloadDataset"
               color="primary">Pobierz</v-btn>
      </v-flex>
      <v-flex xs12
              pt-3>
        <textarea id="query-code"></textarea>
      </v-flex>
      <v-flex xs12
              pt-3>
        <v-btn @click="executeQuery"
               color="primary">Wykonaj</v-btn>
      </v-flex>
      <v-flex v-if="headers && headers.length > 0"
              xs12
              pt-3>
        <v-data-table :headers="headers"
                      :items="items"
                      :items-per-page="5">
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item,i) in items"
                  :key="i">
                <td v-for="(header, index) in headers"
                    :key="index">
                  <template v-if="item[header.value].value && item[header.value].value.startsWith(linkPrefix)">
                    <a :href="item[header.value].value"
                       target="_blank"
                       title="Pokaż obiekt">{{ item[header.value].value }}</a>
                  </template>
                  <template v-else>{{ item[header.value].value }}</template>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-snackbar top
                :timeout="2000"
                v-model="snackbar">{{text}}</v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import YASQE from "yasgui-yasqe";
import "yasgui-yasqe/dist/yasqe.min.css";

export default {
  name: "Home",
  created: function () {
    axios.get(this.$conf('VUE_APP_SERVER_URL') + "datasets").then(response => {
      if (response && response.data) {
        this.datasets = response.data;
      }
    });
  },
  mounted: function () {
    this.yasqe = YASQE.fromTextArea(document.getElementById("query-code"));
    this.yasqe.setValue(this.sparqlQuery);
    document.getElementsByClassName("yasqe_share")[0].style.display = "none";
    this.linkPrefix = document.location.origin;
  },
  methods: {
    downloadDataset: function () {
      if (this.dataset) {
        var element = document.createElement("a");
        element.setAttribute(
          "href",
          this.$conf('VUE_APP_SERVER_URL') + "datasets/" + this.dataset.name
        );
        element.setAttribute("target", "_blank");
        element.setAttribute(
          "download",
          this.dataset.name.replace("/s/g", "_") + ".rdf"
        );

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      } else {
        this.text = "Proszę wybrać zbiór danych.";
        this.snackbar = true;
      }
    },
    executeQuery: function () {
      if (this.dataset) {
        let query = this.yasqe.getValue();
        if (query) {
          this.executeSpecifiedQuery(this.dataset, query, data => {
            this.headers = data.head.vars.map(header => {
              return { text: header, value: header };
            });
            this.items = data.results.bindings;
            this.actualDataset = this.dataset;
          });
        } else {
          this.text = "Proszę wpisać zapytania SPARQL.";
          this.snackbar = true;
        }
      } else {
        this.text = "Proszę wybrać zbiór danych.";
        this.snackbar = true;
      }
    },
    executeSpecifiedQuery (dataset, query, callback) {
      axios
        .post(this.$conf('VUE_APP_SERVER_URL') + "search", {
          dataset: dataset.name,
          query: query
        })
        .then(response => {
          if (response && response.data) {
            if (callback) callback(response.data);
          } else {
            this.text = "Nie udało się wykonać zapytania SPARQL.";
            this.snackbar = true;
          }
        })
        .catch(error => {
          if (error) {
            console.log(error);
          }
          this.text = "Nie udało się wykonać zapytania SPARQL.";
          this.snackbar = true;
        });
    }
  },
  data: () => {
    return {
      dataset: null,
      actualDataset: null,
      datasets: [],
      snackbar: false,
      yasqe: null,
      linkPrefix: null,
      sparqlQuery: `PREFIX dc: <http://purl.org/dc/terms/>
PREFIX spatial: <http://jena.apache.org/spatial#>
PREFIX sipam: <${document.location.origin + "/rdf/sipam/terms/"}>
SELECT * { ?id spatial:withinBox(49.0273953314 14.0745211117 54.8515359564 24.0299857927) ;     dc:title ?title }`,
      text: null,
      items: [],
      headers: []
    };
  }
};
</script>
